//import config from '../config';
import React,{Component} from "react";
//import Paper from "@material-ui/core/Paper";
//import Tab from "@material-ui/core/Tab";
//import Tabs from "@material-ui/core/Tabs";
import logo from "./images/loading.gif";
//import modallogo from "./images/loader.gif";
import save from "./images/save.png";
import fail from "./images/fail.png";
import BusyModal from "./modalwait";
import Cookies from "universal-cookie";
//import Modal from "react-bootstrap/Modal"

//import Table from 'react-bootstrap/Table'
//import AdminNotification from "./AdminNotifications";
const cookies=new Cookies();
const axios = require("axios");
const ref = React.createRef();
class NotificationAdmin1 extends Component{
    constructor(props)
    {
        super(props);
           this.state={input:{},ref:"",ErrMsg2:"",UbuttonED:true,RbuttonED:true,savealert:"",removealert:"",value:0,tab1:"block",tab2:"none",tab3:"none",myitems:[],bdisabled:true,isLoaded:true,inputkey:Date.now() ,errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",filetoupload:null,filename:null,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"};
           this.handleChange = this.handleChange.bind(this);
           this.handleSaveNotification = this.handleSaveNotification.bind(this);
        }
    
    handleSaveNotification=()=> 
    {
        if(this.validate())
        {

        if(this.state.filetoupload !== null)
        {
            document.body.style.cursor ="wait";
            const formdata = new FormData() 
            this.setState({ErrMsg2:<BusyModal/>});
            formdata.append("myfile[]", this.state.filetoupload,this.state.filename);
            formdata.append("ref", this.state.input["ref"]);
            formdata.append("title", this.state.input["title"]);
            formdata.append("desc", this.state.input["desc"]);            
            axios.post(cookies.get("phpclass")+'/index.php/user/AddNotification/',formdata, {
                }).then((res) => {
                if(res.data === 0)
                {
                    this.setState({ErrMsg2:"",savealert:<span><img src={save} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Save Successfully.</span>,errorcss:"labelsave"});
                    this.setState({inputkey:Date.now(),filetoupload: "",filename: "",browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});    
                    document.body.style.cursor ="default";
                }
                else
                {
                    this.setState({ErrMsg2:"",savealert:<span><img src={fail} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Failed to save.</span>,errorcss:"labelerror"});
                    document.body.style.cursor ="default";
                }
           })
        }
        else
        {
            this.setState({error:"Must select a file to upload",errorcss:"labelerror",ErrMsg2:""});
            document.body.style.cursor ="default";
        }
        }
    }        

    Imagechange=(event)=>
    {
        this.setState({error:"",UbuttonED:false,filetoupload: event.target.files[0],filename: event.target.files[0].name,imagefile:URL.createObjectURL(event.target.files[0]),browsecss:"labeblock",savecss:"labelblock",cancelcss:"labelblock"});
    }
    Imagecancel=(event)=>
    {       
        this.setState({inputkey:Date.now(),error:"",filetoupload: "",filename: "",imagefile:this.state.defaultimage,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});
    }

    componentDidMount()
    {
    }

    handleChange=(event)=> 
    {
        this.setState({imagefile:this.state.defaultimage});
    }

    //Change of input fields
    handleFiledsChange=(event)=>
    {
        let input = this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});      
    }

  
    validate(){
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        //For email
        if (typeof input["ref"] == "undefined" || input["ref"].length == 0 ) {      
            isValid = false;
            errors["pref"] = "Please enter reference.";          
        }                
        if (typeof input["title"] == "undefined" || input["title"].length == 0) {      
            isValid = false;
            errors["ptitle"] = "Please enter title.";          
        }                
        if (typeof input["desc"] == "undefined" || input["desc"].length == 0) {      
            isValid = false;
            errors["pdesc"] = "Please enter description.";
        }                
        this.setState({errors: errors});
        return isValid;
    }        
    render(){
        let items = this.state.myitems;
        let isLoaded = this.state.isLoaded;
        if(!isLoaded) 
        {
            return (
                <div className="container1">            
                    <div className="center">
                        {this.state.ErrMsg}
                    </div>
                </div>
            )
        } 
        else 
        {
        return(
/*}            <div width="100%" align="center" height="100%" scroll="hidden" >*/
            <div className="containera1">
            <div className="inner-profile">

                <h5 style={{textAlign:"center"}}>Policies and documents</h5>
                    <div className="inner-profile2" >
                        <form >
                            <div className="form-group row">
                                <br></br>
                                <label>Reference#:</label>
                                <input type="text" name="ref"  value={this.state.input["rref"]} className="form-control" onBlur={this.handleFiledsChange}/>
                                <small id="rpref" className="text-danger">{this.state.errors.pref}</small>
                            </div>
                            <div className="form-group row">
                                <label>Title:</label>
                                <input type="text" name="title" className="form-control" onBlur={this.handleFiledsChange}/>
                                <small id="ptitle" className="text-danger">{this.state.errors.ptitle}</small>
                            </div>
                            <div className="form-group row">
                                <label>Detail or description:</label>
                                <textarea rows={10} name="desc" cols={100} className="form-control" onBlur={this.handleFiledsChange}/>
                                <small id="pdesc" className="text-danger">{this.state.errors.pdesc}</small>
                            </div>
                        </form>
                    </div>
                    <div style={{width:"55%",float:"left",marginLeft:"0px",textAlign:"left",border:"1px"}}>
                        <input
                            type="file"
                            className="form-control"
                            name="myile"
                            onChange={this.Imagechange}
                        />
                        <label className="labelerror" >
                            <span className={this.state.errorcss}>{this.state.error}</span>
                        </label>
                    </div>                            
                    <div style={{width:"15%",float:"left",paddingTop:"5px"}}>
                        <button
                            className=".btn btn-secondary"
                            onClick={this.handleSaveNotification}
                            disabled={this.state.UbuttonED}
                            style={{height:"30px",width:"60px"}} 
                            >Save
                        </button>
                    </div>
                    <div style={{width:"20%",float:"left"}}>
                        <span className={this.state.errorcss}>{this.state.savealert}</span>
                    </div>
{/*}                    <Modal show={this.state.isOpen} onHide={this.onhideModal} animation="false" centered backdrop="static" size="sm">
                    <Modal.Body><img src={modallogo} width="30px" height="30px"/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
        </Modal>*/}
            </div>
            </div>
    )}
}}
export default NotificationAdmin1;